import classes from "./UserEditorDialog.module.css";

import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { Divider } from "primereact/divider";
import useCrudEditorControl from "../../../../custom_hooks/complex/useCrudEditorControl";

import configs from "./UserConfigs";
import DepotSelectorDialog from "../../../../dialogs/selectors/DepotSelectorDialog";
import JabatanSelectorDialog from "../../../../dialogs/selectors/JabatanSelectorDialog";
import RoleSelectorDialog from "../../../../dialogs/selectors/RoleSelectorDialog";

const title = configs.dialog.title;

const UserEditorDialog = (props) => {
  const {
    generateSelectorDialog,
    handleInputChange,
    handleMultipleInputChange,
    elements,
    validator,
  } = useCrudEditorControl({
    value: props.value,
    setValue: props.setValue,
    configs: props.configs,
    error: props.error,
    customElements: props.customElements,
  });

  const convertValue = () => {
    return { ...props.value };
  };

  const validation = () => {
    return validator({
      configs: props.configs,
      value: props.value,
      onError: (error) => props.setError(error),
      isEmpty: "depot_id jabatan_id ",
    });
  };

  // add_generate_selector_dialog
  generateSelectorDialog({
    field: "depot_id",
    componentFunction: ({ visible, setVisible, onConfirm }) => {
      return (
        <DepotSelectorDialog
          single={false}
          visible={visible}
          onHide={() => setVisible(false)}
          onConfirm={onConfirm}
        />
      );
    },
  });

  generateSelectorDialog({
    field: "jabatan_id",
    componentFunction: ({ visible, setVisible, onConfirm }) => {
      return (
        <JabatanSelectorDialog
          single={false}
          visible={visible}
          onHide={() => setVisible(false)}
          onConfirm={onConfirm}
        />
      );
    },
  });

  generateSelectorDialog({
    field: "role_id",
    componentFunction: ({ visible, setVisible, onConfirm }) => {
      return (
        <RoleSelectorDialog
          single={false}
          visible={visible}
          onHide={() => setVisible(false)}
          onConfirm={onConfirm}
        />
      );
    },
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validation();
          if (valid) {
            const newValue = convertValue();
            props.onSave(e, newValue);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={props.visible}
      style={{ width: "48rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={title}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={props.onHide}
    >
      <div className="col-start-center relative h-100">
        <div className={`${classes.wrapper} row-start-start w-100 gap-3`}>
          <div className="col-start-start w-100 gap-3">
            {/* {elements.example_fields} */}
            {/* add_fields */}
            {elements.name}
            {elements.username}
            {elements.nik}
            {elements.email}
            {elements.phone}
          </div>
          <Divider style={{ height: "20rem" }} layout="vertical" />
          <div className="col-start-start w-100 gap-3">
            {elements.role_id}
            {elements.jabatan_id}
            {elements.depot_id}
            {elements.password}
            {elements.cpassword}
            {elements.semua_gudang}
          </div>
        </div>
        {props.loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default UserEditorDialog;
